module.exports = __webpack_public_path__ + "img/pt-soldOut.ce62c8be.png";